import { useSyncExternalStore } from "react";

// One shared 1 s ticker for "5m 12s ago" style labels, instead of a timer per row.
let now = Date.now();
const listeners = new Set<() => void>();
let timer: number | undefined;

function subscribe(fn: () => void) {
  listeners.add(fn);
  if (timer === undefined) {
    timer = window.setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, 1000);
  }
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      window.clearInterval(timer);
      timer = undefined;
    }
  };
}

export function useNow(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}

/** The time rounded down to `step` ms; re-renders only when that changes. */
export function useNowFloor(step: number): number {
  const snap = () => Math.floor(now / step) * step;
  return useSyncExternalStore(subscribe, snap, snap);
}
